import React from 'react'
import { useLocation, useHistory } from 'react-router-dom'

import { PERMISSIONS } from '../../auth/constants'

import { usePermissions, useLogout } from '../../auth/hooks'
import { useUser } from '../../user/hooks'

import styles from './MobileSiteSwitcher.module.css'

const SiteButton = ({ name, url, icon, permissions = [] }) => {
  const location = useLocation()
  const history = useHistory()
  const allowed = usePermissions(permissions)
  const logout = useLogout()

  const active = location.pathname.startsWith(url)

  if (active && !allowed.every((a) => a)) logout() // if you're somewhere you shouldn't be.. logout =D

  if (!allowed.every((a) => a)) return null

  return (
    <button
      onClick={() => !active && history.push(url)}
      className={
        active ? `${styles.active} ${styles.siteLink}` : styles.siteLink
      }
    >
      <i className={`fa ${icon} fa-fw`}></i> {name}
    </button>
  )
}

const MobileSiteSwitcher = ({ tabs }) => {
  const logout = useLogout()

  return (
    <>
      {tabs && <h2 className={styles.menuHeader}>Sections</h2>}
      {tabs &&
        tabs.map(({ name, icon, url, permissions }) => (
          <SiteButton
            name={name}
            icon={icon}
            url={url}
            permissions={permissions}
          />
        ))}
      <h2 className={styles.menuHeader}>Sites</h2>
      <SiteButton
        name="Command Central"
        icon="fa-bullhorn"
        url="/commandCentral"
        permissions={[PERMISSIONS.IRISS_ACCESS]}
      />
      <SiteButton
        name="Palmetto Incidents"
        icon="fa-tree"
        url="/palmetto"
        permissions={[PERMISSIONS.PALMETTO_VIEW]}
      />
      <SiteButton
        name="Significant Events"
        icon="fa-exclamation-circle"
        url="/sigEvents"
        permissions={[PERMISSIONS.SIGNIFICANT_EVENTS_VIEW]}
      />
      <SiteButton
        name="Road Closures"
        icon="fa-exclamation-triangle"
        url="/roadClosures"
        permissions={[PERMISSIONS.ROAD_CLOSURES_VIEW]}
      />
      {/* <SiteButton
            name="Power Outages"
            icon="fa-battery-empty"
            url="/powerOutages"
            permissions={[PERMISSIONS.POWER_OUTAGES_VIEW]}
          /> */}
      <button
        className={`${styles.siteLink} ${styles.signout}`}
        onClick={logout}
      >
        <i className="fas fa-sign-out-alt"></i> Logout
      </button>
    </>
  )
}

export default MobileSiteSwitcher
